import { type ContentfulAssetType } from '@/data/graphql-fragments/ContentfulAsset';

export default function Img(
  props: JSX.IntrinsicElements['img'] & {
    asset: ContentfulAssetType;
  }
) {
  return (
    <img
      alt={props.asset.description}
      height={props.asset.height}
      loading="lazy"
      src={props.asset.url}
      width={props.asset.width}
      {...props}
    />
  );
}
